export const reportNoteAction = {
  setFieldValue: (state, action) => {
    // const { reportNoteIndex, noteIndex, type, value } = action.payload;

    // switch (type) {
    //   case "alert": {
    //     state.values.reportNotes[reportNoteIndex].content[noteIndex].alert =
    //       value;
    //     break;
    //   }
    //   case "link": {
    //     state.values.reportNotes[reportNoteIndex].content[
    //       noteIndex
    //     ].pageNumber = value;
    //     break;
    //   }
    //   case "description": {
    //     state.values.reportNotes[reportNoteIndex].content[
    //       noteIndex
    //     ].description = value;

    //     break;
    //   }
    //   default:
    // }
    state.values[action.payload.name] = action.payload.value;
  },
  setEvokeReportNotes: (state, action) => {
    state.evokeReportNotes = action.payload;
  },

  setOriginalEvokeReportNotes: (state, action) => {
    state.originalEvokeReportNotes = action.payload;
  },
  addNote: (state, action) => {
    const index = action.payload;
    const placeholder = state.values.reportNotes[index].placeholder;

    let newNote = {
      description: placeholder,
      alert: "None",
      pageNumber: null,
    };

    if (state.values.reportNotes[index]?.content?.length > 0) {
      state.values.reportNotes[index].content.unshift(newNote);
    } else {
      state.values.reportNotes[index].content = [newNote];
    }
  },

  getReportNotes: (state, action) => {
    const { evokeNotes, reportTemplates } = action.payload;

    let reportNoteList = evokeNotes ?? [];
    let templates = reportTemplates ?? [];

    const combinedNotes = [...evokeNotes, ...templates];
    const customNotes = combinedNotes.find(
      (section) => section.note === "Custom Notes"
    );

    let noteList = [];
    if (customNotes) {
      const otherNotes = combinedNotes.filter(
        (section) => section.note !== "Custom Notes"
      );
      noteList = [...otherNotes, customNotes];
    } else {
      noteList = [...combinedNotes, { note: "Custom Notes", placeholder: "" }];
    }

    reportNoteList = noteList?.reduce((acc, curr) => {
      const index = acc.findIndex((item) => item.note === curr.note);

      if (index !== -1) {
        acc[index].placeholder = curr.placeholder || acc[index].placeholder;
        acc[index].content = [...acc[index].content, ...(curr.content || [])];
      } else {
        acc.push({
          ...curr,
          placeholder: curr.placeholder || "",
          content: curr.content || [],
        });
      }

      return acc;
    }, []);

    state.values.reportNotes = reportNoteList;
  },

  setSeverityIndex: (state, action) => {
    state.severityIndex = action.payload;
  },

  setReportNoteEditAccess: (state, action) => {
    state.hasReportNoteEditAccess = action.payload;
  },

  setReportNoteEditable: (state, action) => {
    state.isReportNoteEditable = action.payload;
  },

  setReportNotesTouched: (state, action) => {
    state.reportNotesTouched = action.payload;
  },

  setExplicitReportNoteEditable: (state, action) => {
    state.isExplicitReportNoteEditable = action.payload;
  },

  setReportNote: (state, action) => {
    state.reportNote = action.payload;
  },

  removeNote: (state, action) => {
    const { reportNoteIndex, noteIndex } = action.payload;

    delete state.values.reportNotes[reportNoteIndex].content[noteIndex];

    // state.values.reportNotes[reportNoteIndex].content[noteIndex].alert = value;
  },

  setShowEditDiagnosisModal: (state, action) => {
    state.showEditDiagnosisModal = action.payload;
  },

  setBillingDiagnosisCodes: (state, action) => {
    state.billingDiagnosisCodes = action.payload;
  },

  setSaveWithProcess: (state, action) => {
    state.saveWithProcess = action.payload;
  },
  setShowSuggestionModal: (state, action) => {
    const { showModal, displayPopup } = action.payload;
    state.showSuggestionModal = showModal;
    state.displayPopup = displayPopup;
  },
  setReportNoteSuggestions: (state, action) => {
    state.reportNoteSuggestions = action.payload;
  },
};
